<style lang="less" scoped>
.lock-vehicle{
  width: 100%;
  position: relative;
  .lock-vehicle-menu{
    position: absolute;
    top: 0;
    right: 0;
  }
}
</style>

<template>
  <div class="lock-vehicle" v-if="vin && detail" >
    <DescriptionList :title="'锁车状态'" :data="detail" :list="description" :collapse="collapse" @collapse="onCollapseChange" />
    <div v-if="!collapse" class="lock-vehicle-menu">
      <a-button type="primary" :disabled="!validAgreement" @click="openLock">锁车</a-button>
    </div>
    <ComplexAutoModal ref="modal" :optionProps="{ width: 960, destroyOnClose: true }" :top="50" :bottom="50" :menuType="{ target: 'cancel', name: '关闭' }">
      <template #default="{ width, height }">
        <LockLog :vin="vin" :agreement="validAgreement" :width="width" :height="height" />
      </template>
    </ComplexAutoModal>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import { notice } from 'complex-plugin'
import { ComplexAutoModal } from 'complex-component/antd'
import DescriptionList from './../DescriptionList.vue'
import LockLog from './LockLog.vue'
import vehicleApi from '../../api/vehicle'
import { vehicleOnlineStatus, vehicleAgreement } from '../../select/vehicle'
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { resetEnvData } from 'complex-utils'

export default defineComponent({
  name: 'LockVehicle',
  components: {
    ComplexAutoModal,
    DescriptionList,
    LockLog
  },
  props: {
    vin: {
      type: String,
      required: true
    },
    defaultCollapse: {
      type: Boolean,
      required: false
    }
  },
  data() {
    return {
      collapse: this.defaultCollapse,
      detail: {} as any,
      description: [
        {
          name: '车联网状态',
          prop: 'onlineState',
          format(value: any) {
            return vehicleOnlineStatus.getItem(value).label as string
          }
        },
        {
          name: '平台',
          prop: 'agreement',
          format(value: any) {
            return vehicleAgreement.getItem(value).label as string
          }
        },
        {
          name: '数据刷新时间',
          prop: 'gatime'
        },
        {
          name: '车辆位置',
          prop: 'position'
        },
        {
          name: '定位状态',
          prop: 'locsts2'
        },
        {
          name: '累计里程',
          prop: 'tmiles'
        },
        {
          name: '锁车状态',
          prop: 'lockDesc'
        },
        {
          name: '锁车支持',
          prop: 'lockSupport'
        }
      ]
    }
  },
  computed: {
    validAgreement() {
      return (vehicleAgreement.getItem(this.detail.agreement)?.value as string) || ''
    }
  },
  watch: {
    vin: {
      immediate: true,
      handler(val) {
        if (val) {
          this.getDetail()
        }
      }
    }
  },
  methods: {
    openLock() {
      (this.$refs.modal as any).show('锁车控制')
    },
    getDetail() {
      if (this.vin) {
        const vin = this.vin
        // let vin = this.vin
        // resetEnvData(() => {
        //   vin = 'TESTDT01ZD2022028'
        // })
        vehicleApi.vehicleRealTime.require({
          vin: vin
        }).then((res) => {
          if (res.data.data) {
            this.detail = res.data.data || {}
          } else {
            this.detail = {}
            notice.showMsg('此车辆无实时数据！', 'error')
          }
          vehicleApi.vehicleSupportLock.require({
            vin: vin
          }).then((res) => {
            this.detail.lockSupport = res.data.data === 'Y' ? '是' : '否'
          })
        })
      }
    },
    onCollapseChange(value: boolean) {
      this.collapse = value
    }
  }
})
</script>
